export default class CtaButton {
	constructor($element) {
		this.$element = $element;

		window.addEventListener('resize', () => {
			if (this._isResponsive()) {
				$('.footer-bar').css('--cta-button-height', `${this.$element.outerHeight() + 5}px`);
			} else {
				$('.footer-bar').css('--cta-button-height', ``);
			}
		});

		this._setOffset();

		if ($(window).scrollTop() > 300) {
			this.$element.addClass('show');
		}

		window.addEventListener('scroll', () => {
			this._setOffset();

			if ($(window).scrollTop() > 300) {
				this.$element.addClass('show');
			}
		});
	}

	centerText() {
		const $div = this.$element.find('.cta-button-text > .horizontal-alignment');
		$div.css('padding-top', `${$div.parent().outerHeight() / 2 - $div.outerHeight() / 2 - 2}px`);
	}

	_isResponsive() {
		return $(window).width() < 1024;
	}

	_setOffset() {
		if ((window.innerHeight + window.scrollY + 30) >= document.body.offsetHeight) {
			this.$element.addClass('scrolled-bottom');
		} else {
			this.$element.removeClass('scrolled-bottom');
		}
	}
}
